import { createTheme, type ThemeOptions } from '@mui/material';
import { palette } from './palette';
import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { components } from './components';

const spacing = {
  none: 0,
  xxxs: 2,
  xxs: 4,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 36,
  xxl: 48,
  xxxl: 64,
};

const spacingPx = {
  none: '0px',
  xxxs: '2px',
  xxs: '4px',
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '24px',
  xl: '36px',
  xxl: '48px',
  xxxl: '64px',
};

const radius = {
  xs: '4px',
  md: '8px',
  lg: '12px',
};

export const styledTheme = {
  palette,
  typography,
  spacing,
  breakpoints,
  components,
  s: spacingPx,
  radius,
};

export const theme = createTheme({
  palette,
  typography,
  spacing: Object.values(spacing),
  breakpoints,
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- augmented Theme palette omits CssVarsPalette; components object is structurally compatible
  components: components as ThemeOptions['components'],
});
